@if (notifications$ | async; as notifications) {
  <div class="top-section flex justify-start content-center items-center flex-row">
    <mat-icon
      class="bell"
      matBadgeSize="small"
      matBadgeColor="warn"
      data-test-id="notifications-dialog-unread-count"
      [matBadge]="notifications.count"
      [matBadgeHidden]="!notifications.count"
    >
      notifications
    </mat-icon>
    <h2 data-test-id="notifications-dialog-title">My notifications</h2>
    <mat-icon class="close" data-test-id="notifications-dialog-close" (click)="closeModal()"> close </mat-icon>
  </div>
  <div class="archive-container flex justify-between content-stretch items-stretch">
    <mat-button-toggle-group [ngModel]="searchFilter$ | async" (ngModelChange)="filterNotifications($event)">
      <mat-button-toggle data-test-id="notifications-dialog-toggle-current" [value]="false">
        Current
      </mat-button-toggle>
      <mat-button-toggle data-test-id="notifications-dialog-toggle-archived" [value]="true">
        Archived
      </mat-button-toggle>
    </mat-button-toggle-group>
    @if ((searchFilter$ | async) === false && notifications.count) {
      <button mat-button data-test-id="notifications-dialog-clear-all" (click)="clearNotifications()">
        Clear all notifications
      </button>
    }
  </div>
  <div class="notifs" data-test-id="notifications-dialog-notification-list">
    @for (notif of notifications.notifs; track notif) {
      <app-notification
        class="notif-container flex flex-col gap-4"
        data-test-id="notifications-dialog-notification-list-item"
        [notification]="notif"
        (archiveNotification)="archiveNotification($event)"
        (routeAction)="routeAction($event)"
      ></app-notification>
    }
  </div>
}
